var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"parentMenu"}},[_vm._v(_vm._s(_vm.$t('admin.selectedMenu')))]),_vm._v(" "),_c('select',{staticClass:"form-control",attrs:{"id":"parentMenu"}})]),_vm._v(" "),_c('div',{staticClass:"form-group text-muted"},[_vm._v(_vm._s(_vm.menuDescription))])])
}
var staticRenderFns = []

export { render, staticRenderFns }